<div class="container notifications">
  <div
    *ngFor="let notification of notifications$ | async"
    class="alert alert-dismissible fade show"
    [class.line-on-top]="showLineOnTop"
    [ngClass]="notification.notificationType | asBootstrapClass"
    role="alert">
    <div class="row align-items-center h-100">
      <div class="col pr-0 flex items-center">
        <div class="main-icon" [ngSwitch]="notification.notificationType">
          <yat-icon *ngSwitchCase="'success'" name="tick-circle-duo" [title]="'uiTools.notification.notificationOutlet.success' | transloco"></yat-icon>
          <yat-icon *ngSwitchCase="'info'" name="info-duo" [title]="'uiTools.notification.notificationOutlet.info' | transloco"></yat-icon>
          <yat-icon *ngSwitchCase="'refresh'" name="info-duo" [title]="'uiTools.notification.notificationOutlet.refresh' | transloco"></yat-icon>
          <yat-icon *ngSwitchCase="'warning'" name="warning-duo" [title]="'uiTools.notification.notificationOutlet.warning' | transloco"></yat-icon>
          <yat-icon *ngSwitchCase="'error'" name="cross-circle-duo" [title]="'uiTools.notification.notificationOutlet.error' | transloco"></yat-icon>
        </div>
        <yat-notification-message id="49b97910-f39f-4025-867a-e45dcb221f87" [message]="notification.message" class="message"></yat-notification-message>
      </div>
      <div class="col-1 text-right">
        <yat-button id="bb43c1d5-24e7-4d83-82d0-63d1b739bd85"
          type="button"
          class="close spinner-dark"
          aria-label="Close"
          (click)="dismiss(notification)"
          [yatAutoSpinner]="notification | asActionFilter"
          [hideContentWhileSpinning]="true">
          <span aria-hidden="true">
            <yat-icon name="cross" [title]="'close' | commonWording | async"></yat-icon>
          </span>
        </yat-button>
      </div>
    </div>
  </div>
</div>
